import { rj } from 'react-rocketjump'
import { ajax } from 'rxjs/ajax'
import qs from 'query-string'

export const ManipolazioniState = rj({
  name: 'ManipolazioniState',
  effect: (filters) => ajax.getJSON(`/api/planner/manipolazioni-macchina-list/?${qs.stringify(filters)}`),
})
